var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout", {}, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c(
          "form",
          {
            attrs: {
              autocomplete: "off",
              method: "post",
              "data-vv-scope": "form",
            },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
              },
              submit: function ($event) {
                $event.preventDefault()
                return _vm.saveItem.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "row mb-3" }, [
              _c("div", { staticClass: "col-sm-auto" }, [
                _c("h1", { staticClass: "content-title" }, [
                  _vm._v(_vm._s(_vm.form.title)),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "form-group form-inline flex-nowrap align-items-start",
                  },
                  [
                    _c("label", [_vm._v("Tipo:")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-control-static" }, [
                      _vm._v(
                        _vm._s(
                          _vm.form.service
                            ? _vm.form.service.description
                            : _vm.emptyField
                        )
                      ),
                    ]),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "form-group form-inline flex-nowrap align-items-start",
                  },
                  [
                    _c("label", [_vm._v("URL:")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-control-static" }, [
                      _vm._v(_vm._s(_vm.form.url)),
                    ]),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.form.description
              ? _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group form-inline flex-nowrap align-items-start",
                      },
                      [
                        _c("label", [_vm._v("Abstract:")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-control-static" }, [
                          _vm._v(_vm._s(_vm.form.description)),
                        ]),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "form-group form-inline flex-nowrap align-items-start",
                  },
                  [
                    _c("label", [_vm._v("Abstract:")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-control-static" }, [
                      _vm._v(
                        _vm._s(
                          _vm.form.abstract ? _vm.form.abstract : _vm.emptyField
                        )
                      ),
                    ]),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-sm-4" }, [
              _c("div", { staticClass: "col" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "form-group form-inline flex-nowrap align-items-start",
                  },
                  [
                    _c("label", [_vm._v("Keywords:")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-control-static" }, [
                      _vm._v(
                        _vm._s(
                          _vm.form.keywords ? _vm.form.keywords : _vm.emptyField
                        )
                      ),
                    ]),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col" }, [
                _c("h3", [
                  _vm._v("Service Resources "),
                  _c("span", { staticClass: "ml-1 badge badge-info" }, [
                    _vm._v(_vm._s(_vm.form.layers_count)),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _vm.form.layers_count > 0
              ? _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("table-data", {
                        attrs: {
                          route: _vm.url.getResources.replace(
                            ":id",
                            this.$route.params.id
                          ),
                          settings: _vm.table.settings,
                          columns: _vm.columns,
                          inlineFilters: _vm.table.filters,
                          autoUpdateFilter: _vm.table.autoUpdateFilter,
                          addParamsToUrl: _vm.table.addParamsToUrl,
                          loadingMsg: _vm.table.loadingMsg,
                          notFoundMsg: _vm.table.notFoundMsg,
                          orderByTemplate: _vm.table.orderByTemplate,
                          tableClass: "",
                        },
                        on: { "error-load": _vm.showError },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "body",
                              fn: function ({ row, index, remove }) {
                                return [
                                  _c(
                                    "td",
                                    { class: _vm.table.columns[0].class },
                                    [_vm._v(_vm._s(row.title))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { class: _vm.table.columns[1].class },
                                    [_vm._v(_vm._s(row.abstract))]
                                  ),
                                  _vm._v(" "),
                                  _vm.canHarvest
                                    ? _c("column-actions", {
                                        attrs: { row: row, index: index },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({
                                                confirm,
                                                formatMsg,
                                              }) {
                                                return [
                                                  _c(
                                                    "li",
                                                    {
                                                      attrs: {
                                                        title:
                                                          "Unlink Resource",
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "cursor-pointer fas fa-unlink action delete",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            confirm(
                                                              (id, data) => {
                                                                _vm
                                                                  .unlinkResource(
                                                                    id,
                                                                    data
                                                                  )
                                                                  .then(
                                                                    (data) => {
                                                                      if (
                                                                        data
                                                                      ) {
                                                                        _vm.form
                                                                          .layers_count--
                                                                        return remove(
                                                                          data.id,
                                                                          data.index
                                                                        )
                                                                      }
                                                                    }
                                                                  )
                                                              },
                                                              row.id,
                                                              index,
                                                              formatMsg(
                                                                _vm.unlinkResourceTemplate
                                                              )
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      })
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2633226734
                        ),
                      }),
                    ],
                    1
                  ),
                ])
              : _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col" }, [
                    _c("p", [_vm._v(_vm._s(_vm.noResources))]),
                  ]),
                ]),
            _vm._v(" "),
            _c("buttons-footer", {
              attrs: {
                enableButtons: !_vm.readonlyFormItem && _vm.canHarvest,
                cancelTitle: _vm.btnBackTitle,
                submitTitle: _vm.submitTitle,
                isDisabled: false,
              },
              on: {
                save: _vm.harvest,
                cancel: function ($event) {
                  return _vm.handleBack(`${_vm.moduleCode}.${_vm.pageID}`, true)
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }